import * as React from "react";
import Mainlayout from "../components/layouts/MainLayout";
import DraftChat from "../features/draft/components/DraftChat";
import { AssistantAdapter } from "../platform";

export interface DraftModeProps {
  assistant: AssistantAdapter;
  modeBar?: React.ReactNode;
}

const DraftMode = ({ assistant, modeBar }: DraftModeProps) => {
  // The right of the mode row is DraftChat's New chat button. The row belongs to the
  // layout and the button's state to the chat, so the layout renders an empty slot and
  // the chat portals into it.
  const [newChatSlot, setNewChatSlot] = React.useState<HTMLElement | null>(null);

  return (
    <Mainlayout modeBar={modeBar} modeBarEnd={<div ref={setNewChatSlot} className="flex" />}>
      <DraftChat assistant={assistant} newChatSlot={newChatSlot} />
    </Mainlayout>
  );
};

export default DraftMode;
